console.log("Hello from footer!");
